import React, { useEffect, useState, useRef } from "react";
import Header from "../components/global/Header";
import LeftNavbar from "../components/global/LeftNavbar";
import RightModal from "../components/project/RightModal";
import { Link ,useLocation,useSearchParams} from "react-router-dom";
import DataTable, { createTheme } from "react-data-table-component";
import { putAxiosResponse, getAxiosResponse, postAxiosResponse } from "../services/authApiRoutes/APImethods";
import APIUrls from "../services/APIUrls";
import { dateFormat, getDepartmentObject, utcDateTimeWithTimeZoneWithFormat , getRangeDates} from "../services/Util";
import Constants from "../Constants";
import FilterProject from "../components/dashboard/FilterProject";
import { updateSourceFiles } from "../redux/reducers/SourceFilesSlice";
import { RotatingLines } from "react-loader-spinner";
import ProjectDetailModal from "../components/project/ProjectDetailModal";
// import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
// import Select from "react-select";
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { setDefaultValueForFilter, updateSelectedFilters } from "../redux/reducers/ProjectFilterSlice";
import { transformBlankToNull } from '../services/Util';
import { projectCreationStepFilter } from '../redux/reducers/ProjectCreationStepSlice';
import { updateTargetLanguage } from "../redux/reducers/CreateProjectTargetLanguageSlice";
import { updateSourceLanguage } from "../redux/reducers/CreateProjectSourceLanguageSlice";
import { departmentSelected } from "../redux/reducers/CreateProjectDepartmentSelectSlice";
import { updateProjectFollowers } from "../redux/reducers/ProjectInfoSlice";
import { updateInitializedProjectWorkflows } from "../redux/reducers/InitializedProjectWorkflowsSlice";
import { updateProjectInfoConfiguration } from "../redux/reducers/ProjectInfoConfigurationSlice";
import { updateProjectInfoValidation } from "../redux/reducers/ProjectInfoValidationSlice";
import { updateProjectInfo } from "../redux/reducers/ProjectInfoSlice";
import { getLoggedInUserRole } from "../services/Util";
import $ from "jquery";
import { Breadcrumb } from "../components/dashboard/Breadcrumb";

import {  useTranslation } from 'react-i18next';

import { TourProvider } from "@reactour/tour";
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import "@reactour/popover/dist/index.css";
import steps from "../services/tourJson/project-listing";
import { updateAllUserGroupFollowers, updateFollowersCollection } from "../redux/reducers/ProjectFollowersSlice";
import { FilterIcon, PlusIcon } from "../AppIcons";
import ProjectCreationWithTemplate from "../components/project/ProjectCreationWithTemplate";
import { ConditionalBlock } from '../ConditionalBlock';
import { updateAsyncUploadAssetCompletedFiles, updateAsyncUploadAssetInProgressFiles, updateAsyncUploadAssetPendingFiles, updateCanSubmitTranslation, updateReadyForValidation, updateValidationErrors } from "../redux/reducers/AsyncAssetUploadSlice";
import { updateBidRequestInfo } from "../redux/reducers/BidRequestSlice";
import DateFormat from "./DateFormat";


export default function ProjectList(prop) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [params ,setParams] =useSearchParams();
  const id = params.get('id'); 
  const tag = params.get('tag'); 
  const [prevPayload,setPrevPayload] = useState({})
  const roleArray = getLoggedInUserRole();
  const {state,search} = useLocation();
  const searchKey = new URLSearchParams(search).get('id');
  const { t } = useTranslation();
  const [selectedProjectStatus,setSelectedProjectStatus] = useState({})
  const translate = t;
  const globalSearch = localStorage.getItem("globalSearch");
  const paginationRef = useRef();
  const [templates,setTemplates] = useState([]);
  const [sortFocus, setsortFocus] = useState('');
  const custBootstrapDataRedux = useSelector(
    (store) => store.customer_bootstrap_data
  ).value;
  useEffect(() => {
    document.title = "OPAL-Marketing | The Marketing Globalization Platform - Projects";
    $(".rdt_TableCell a").attr("projectlisting-tour","datatable-title"); 
    $(".rdt_TableRow:first").attr("projectlisting-tour","datatable-row"); 
  });

  $(document).ready(function(){
    $(".rdt_Table .rdt_TableCol span").attr("aria-hidden","true");
    $(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1");
   })

  useEffect(() => {
    if(tag !==null){
      const selectedFilters = {
        Tags:  {label: tag, value: id} ,
      };  
      dispatch(updateSelectedFilters(selectedFilters));
    }else{
     dispatch(updateSelectedFilters({}));
    }
  },[tag]);

  let intendedUseId;
  let department;
  const[globalOverlay,showGlobalOverlay] = useState(false);
  const [selectRighModal,setRightModal] = useState(false);
  const [openFilter , setOpenfilter] = useState(false)
  const [projectDetail,setProjectDetail] = useState([]);
  const [projectType, setType] = useState("");
  const [projectData,setProjectData] = useState({})
  // const [showCalendar, updateCal] = useState(false);
  const [data, updateList] = useState([]);
  const [projOptions, toggleProjOption] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, updateCurrentPage] = useState(1);
  // const [prevPage, updatePrevPage] = useState(1);
  const [sort, setSort] = useState("");
  //  const [departments, fetchDepartments] = useState([]);
  const [projectDeliveryStatusCount, updateCount] = useState([]);
  const [loader, showLoader] = useState(true);
  const projectFilters = useSelector((reduxStore) => reduxStore.project_filters);
  const projectConfigurationStatus = [
    'configured_project_name',
    'uploaded_source_materials',
    'configured_bid_options',
    'configured_project_workflow',
    'configured_project_details'
  ];
  const scrollRef = useRef(null);
  const cloneRef  = useRef(null);
  const tabRef = useRef(null)
  const generateTicket = () => {
    window.location.href = Constants.TICKET_GENERATE_EXTERNAL_LINK
  };
  const selectedRange = useSelector((CalendarRangeSlice) => CalendarRangeSlice.calendar_range).range;
  const selectedDateRangeRedux = getRangeDates(selectedRange);
  const selectedDepatmentRedux = useSelector((departmentSelected) => departmentSelected.select_dropdown).value;
  const getPermissionsRedux = useSelector((rolePermissionSelected) => rolePermissionSelected.role_permission).value;
  const [searchText, setSearchText] = useState('');
  const searchParameter = searchText !== null && searchText!== undefined !== "" ? `&projectName=${searchText}` : "";
  const followed = useSelector((FollowingSlice) => FollowingSlice.follow).value;
  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const theme = aaaSelected ? "dark" : "";
  const columns = [
    {
      id: "project.name",
      name: `${translate("project_listing.project_name")}`,

      selector: (row) => row.name,
      sortable: true,
      cell: (row) => (
          <Link
            style={{
              color: aaaSelected ? "#FFF" : "#4067D6",
              fontWeight: 500,
              position: "relative",
            }}
            to={`/project/${row.id}`}
          >
            {row.name}
          </Link>
       ),
    },
    {
      id: "project.projectContentType",
      name: `${translate("project_listing.content_source")}`,
      selector: (row) => row.projectContentTypeDisplay,
      sortable: true,
      cell: (row) => (
        <div aria-label={row.projectContentTypeDisplay} onClick={()=> rowClicked(row)}>
          {row.projectContentTypeDisplay}
        </div>
      ),
    },
    {
      id: "projectQueryResult.alertCount",
      name: `${translate("project_listing.alerts")}`,
      selector: (row) => row.alertCount,
      sortable: true,
      cell: (row) => (
        <div aria-label={row.alertCount} className="flex-center aaa-alert-icon alert-text" onClick={()=> rowClicked(row)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M8 6V9.33333M8 11.6667V12"
              stroke="#F04067"
              strokeLinecap="round"
            />
            <path
              d="M1.48801 12.6773L6.90001 2.03463C7.37534 1.0993 8.62668 1.0993 9.10134 2.03463L14.5127 12.6773C14.9667 13.5733 14.3627 14.6666 13.4107 14.6666H2.58868C1.63734 14.6666 1.03268 13.5733 1.48868 12.6773H1.48801Z"
              stroke="#F04067"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
           {row.alertCount}
        </div>
      ),
    },
    {
      id: "project.createdDate",
      selector: (row) => row.createdDate,
      name: `${translate("project_listing.created_on")}`,
      sortable: true,
      cell: (row) => (
        row.createdDate !== "" ? 
        <div onClick={()=> rowClicked(row)}>
          <DateFormat date={row.createdDate}/>
        </div> : ""
      ),
    },
    {
      id: "project.requestedDate",
      name: `${translate("project_listing.delivery_date")}`,
      selector: (row) => row.deliveryDueDate,
      sortable: true,
      cell: (row) => (
        row.deliveryDueDate !== "" ?
        <div onClick={()=> rowClicked(row)}>
          <DateFormat date={row.deliveryDueDate}/>
        </div>
        : ""
      ),
    },
    {
      id: "projectQueryResult.dueDate",
      name: `${translate("project_listing.due_date")}`,
      selector: (row) => row.dueDate,
      sortable: true,
      cell: (row) => (
        row.dueDate !== "" ?
        <div onClick={()=> rowClicked(row)}>
          <DateFormat date={row.dueDate}/>
        </div>
        : ""
      ),
    },
    {
      id: "project.status",
      name: `${translate("project_listing.status")}`,
      selector: (row) => row.status.code,
      sortable: true,
      cell: (row) => ( 
         
        row.status.code !== "" ?
        <div tabIndex={0} aria-label={translate(`project_listing.${row.status.code}`)} onClick={()=> rowClicked(row)} onKeyDown={(e)=> handlingRowClicked(e, row)}>
       {translate(`project_listing.${row.status.code}`)}
          </div> : ''
      ),
    },

    {
      id: "project.owner",
      name: "Owner",
      selector: (row) => row.status.display,
      sortable: true,
      cell: (row) => (
        row.owner !== "" ?
        <div aria-label={row.owner.firstName + ' '+row.owner.lastName} onClick={()=> rowClicked(row)}>
          {row.owner.firstName + ' '+row.owner.lastName}
        </div> : ''
      ),
    },
    {
      id: "project.customerAmount",
      name: "Amount",
      selector: (row) => row.status.display,
      sortable: true,
      cell: (row) => (
        row.amount.displayWithDecimals !== "" ?
        <div aria-label={row.amount.displayWithDecimals} onClick={()=> rowClicked(row)}>
          {row.amount.displayWithDecimals}
        </div> : ''
      ),
    },
    {
      id: "project.priority",
      name: "Priority",
      selector: (row) => row.priority,
      sortable: true,
      cell: (row) => (
        row.priority !== "" ?
        <div aria-label={row.priority} onClick={()=> rowClicked(row)}>
          {row.priority}
        </div> : ''
      ),
    },
    {
      id: "projectQueryResult.vendor_name",
      name: "Vendor",
      selector: (row) => row.vendor,
      sortable: true,
      cell: (row) => (
        <div aria-label={row.vendor.name} onClick={()=> rowClicked(row)}>
          {getVendorName(row)}
        </div>
      ),
    },
    {
      id: "project.id",
      name: "Project Id",
      selector: (row) => row.id,
      sortable: true,
      cell: (row) => (
        row.id !== "" ?
        <div aria-label={row.id} onClick={()=> rowClicked(row)}>
          {row.id}
        </div> : ''
      ),
    },
  ];

  const getVendorName = (row) => {
    const { firstName = '', lastName = '' } = row?.internalTranslator || {};
    switch (row?.projectVendorType) {
      case Constants.EXTERNAL:
      case Constants.EXTERNAL_BIDLESS:
        return row.vendor.name;
      case Constants.INTERNAL:
        return firstName || lastName ? `${firstName} ${lastName}` : '';
      case Constants.MACHINE_TRANSLATION:
        return row?.translationEngineType?.display;
      default:
        return;
    }
  };

  //if(dateRange[0] !== '' && dateRange[1] !== ''){
  const startDate = dateFormat(selectedDateRangeRedux[0], Constants.DATE_FORMAT_MM_DD_YYYY);
  const endDate = dateFormat(selectedDateRangeRedux[1], Constants.DATE_FORMAT_MM_DD_YYYY);
  const departmentId = selectedDepatmentRedux !== '' ? `&userGroupIds=${selectedDepatmentRedux}`: "";
  const dateRangeIntial = (startDate !== "" && endDate !== "") ? `&startDate=${startDate}&endDate=${endDate}` : "";

  // }

  useEffect(() => {
    if(searchKey !== null && searchKey !== undefined){
      setSearchText(searchKey);
    }
  },[searchKey]);

  useEffect(()=>{
    if(state !== null && state!== undefined){
      setTimeout(()=>{
        showLoader(true);
        showGlobalOverlay(true)
        if(state.projectType === '&projectStatusChangeOrderRequested=true&projectStatusInTranslation=true&projectStatusInCancellation=true&'){
          setType('&projectStatusInTranslation=true')
        }
        else if(state.projectType === '&projectStatusSubmittedForBids=true&projectStatusWaitingForBidSelection=true&projectStatusWaitingForInternalTranslator=true&projectStatusRejectedByInternalTranslator=true&projectStatusWaitingForVendorAcceptance=true&projectStatusRejectedByVendor=true'){
          setType('&projectStatusSubmittedForBids=true&projectStatusWaitingForBidSelection=true&projectStatusWaitingForInternalTranslator=true&projectStatusRejectedByInternalTranslator=true&projectStatusWaitingForVendorAcceptance=true&projectStatusRejectedByVendor=true&bidding=true')
        }
        else{
          if(state?.screen==="dashboard"){
            if(state.projectType ==="projectStatusOpen"){
              setType("");
            }else if(state.projectType ==="inBidding"){
              setType("&projectStatusSubmittedForBids=true&projectStatusWaitingForBidSelection=true&projectStatusWaitingForInternalTranslator=true&projectStatusRejectedByInternalTranslator=true&projectStatusWaitingForVendorAcceptance=true&projectStatusRejectedByVendor=true&bidding=true");
            }
            else if(state.projectType ==="projectStatusAllTranslationApproved"){
              setType("&projectStatusAllTranslationApproved=true&allLanguageApproved=true");
            }else if(state.projectType==="projectStatusBidSelectionExpired"){
              setType("&projectStatusInBidding=true&projectStatusBidSelectionExpired=true")
            }else if(state.projectType==="projectStatusWaitingForBidSelection"){
             setType("&projectStatusInBidding=true&projectStatusWaitingForBidSelection=true")
            }
            else if(state.projectType==="projectStatusAllBidsRejected"){
              setType("&projectStatusInBidding=true&projectStatusWaitingForBidSelection=true")
             }else if(state.projectType==="projectStatusWaitingForBidSelection"){
              setType("&projectStatusInBidding=true&projectStatusAllBidsRejected=true")
             }else if(state.projectType==="projectStatusWaitingForBidSelection"){
              setType("&projectStatusInBidding=true&projectStatusWaitingForBidSelection=true")
             }else{
              setType("&"+state.projectType+"=true");
             }
          }else{
            setType(state.projectType);
          }
        }
        showLoader(false);
        showGlobalOverlay(false)
      },3000);
    }
  },[state]);
 
  const handleChange = ({ selectedRows }) => {
    setSelectedProjectStatus(selectedRows[0]?.status)
    selectedRows?.length ===1 ? toggleProjOption(true) : toggleProjOption(false);
    if(selectedRows.length > 0 && !projectConfigurationStatus.includes(selectedRows[0].status.code)){
      const projectId = selectedRows[0].id;
      getAxiosResponse(APIUrls.PROJECT(projectId))
        .then((res) => {
          if (res.data.data) {
            setProjectData(res.data.data);
            if(selectedRows.length === 1){ 
            setTimeout(()=>{
              cloneRef.current.focus()
            },500) }
          }
        }).catch(err=>{
          console.error(err)
        })
      }
  };

  const showRightModel = (state) => {
    setRightModal(state);
    setTimeout(() => {
      $("#close-right-popup").trigger("focus");
    }, 300);

    if(state === false){
      if(openFilter){
        document.body.classList.remove("modal-open");
        setOpenfilter(false)
        $("#project-filters").trigger("focus");
      }else{
        setOpenfilter(true)
        document.body.classList.add("modal-open");
      }
    }
    document.body.classList.add("modal-open");
  };

  const noDataFoundComponent = () => {
    return (
      <div role="rowgroup">
        <div role="row" className="no-data-display align-center">
          <div role="cell">
            <i className="nodata-icon"></i>
            <p>{Constants.NO_DATA_FOUND}</p>
          </div>
        </div>
      </div>
    );
  }

  $('.rdt_Table input').parent().attr("role","cell")

  const filterFunction = () => {
    var element = document.getElementById("filterBtn");
    var element2 = document.getElementById("activeId");
    element.classList.toggle("show-flex");
    element2.classList.toggle("active");
     $('#activeId').attr('aria-expanded', function(_, attr) {
      return attr === 'false' ? 'true' : 'false';
    });
  };

  const getAllTemplates = ()=>{
    getAxiosResponse(APIUrls.PROJECT_TEMPLATE+"?enabled=true")
    .then((response)=>{
        const data = response.data.data;
        let showData = data?.map(({name,id})=> ({label:name,value:id}));
        if(showData !== undefined){
          setTemplates(showData);
        }
    }).catch((err)=>{
        console.error(err);
    });
  };

  const openTemplateModal = ()=>{
    document.body.classList.add("modal-open-9");
  };

  const createProject = (event)=>{
    showGlobalOverlay(true);
    if(!roleArray.includes('ROLE_VENDOR')){
      getAxiosResponse(APIUrls.DEPARTMENT_INCLUDE_SYSTEM_IF_POPULATED)
      .then((res) => {        
        if (res?.data?.code === 200) {   
          if (res?.data?.code === 200) {   
            const allDepartments=res?.data?.data
              if(allDepartments && allDepartments.length){
                department=getDepartmentObject(allDepartments)
                getIntendedUseForProjectCreation();
              }                
          }                
        }
      }).catch(err=>{
        console.error(err)
      })
    }
  };
  
  const cloneProject = () =>{
    postAxiosResponse(APIUrls.CLONE_PROJECT(projectData.resource.projectResource.id))
    .then((res) => {
      dispatch(projectCreationStepFilter("Source Material Step 1"))               
      dispatch(updateSourceLanguage({})); 
      dispatch(updateTargetLanguage([]));    
      dispatch(departmentSelected(""));
      dispatch(updateProjectFollowers([]));
      dispatch(updateInitializedProjectWorkflows([]));
      dispatch(updateProjectInfoValidation({}));
      dispatch(updateProjectInfoConfiguration({}));
      dispatch(updateProjectInfo({}));
      let newProjectId = res?.data?.data?.id
      navigate(`/createProject/${newProjectId}?projectType=clone&label=${projectData?.resource?.projectResource?.userGroup?.name}&value=${projectData?.resource?.projectResource?.userGroup?.id}`);
    })
  };

  const cancelProject = () =>{
    var payload = projectData.resource.projectResource;
    payload.status = "CANCELLED"
    var finalPayload = transformBlankToNull(payload)
    putAxiosResponse(APIUrls.PROJECT(projectData.resource.projectResource.id),finalPayload)
    .then((res) => {
      toggleProjOption(false)
      setType("&projectStatusCanceled=true");
    }).catch(err=>{
      console.error(err)
    })
  };

  const getIntendedUseForProjectCreation =() =>{
    getAxiosResponse(APIUrls.INTENDED_USE).then((res) => {

      if (res.data.code === 200) {
        const minimumIntendedUseId = Math.max(...res.data.data.map(x=>x.id))
        intendedUseId = minimumIntendedUseId;
        triggerProjectCreation();
      }
     }).catch(err=>{
      console.error(err)
    })

  };

  const triggerProjectCreation = () =>{
    dispatch(updateSourceFiles([]));
    dispatch(updateAsyncUploadAssetPendingFiles({}))
  dispatch(updateAsyncUploadAssetCompletedFiles([]))
  dispatch(updateAsyncUploadAssetInProgressFiles([]))
  dispatch(updateValidationErrors([])) 
  dispatch(updateReadyForValidation(false));
  dispatch(updateCanSubmitTranslation(true)); 
  dispatch(updateBidRequestInfo({}));
    postAxiosResponse(APIUrls.CREATE_PROJECT,{"status":"CONFIGURED_BASIC_PROJECT_INFO", 
    "projectFollowers":null,
    "name":"-----",
    "intendedUse": {
            "id": intendedUseId
        },
        "userGroup":department
        })
        .then((res) => {

            const projectId = res.data.data.id;
            let projectResource = transformBlankToNull(res.data.data);
            //deleted  this key as it was giving 400 
            delete projectResource["owner"];
            delete projectResource["projectFollowers"];    
            if(projectResource["workspace"] && projectResource["workspace"]['workspaceMembers']){
              delete projectResource["workspace"]['workspaceMembers'];
            }          
            projectResource.name=`Project-${projectId}`;
            projectResource.intendedUse = {"id":projectResource.intendedUse.id};
            projectResource.targetLanguages = []
            putAxiosResponse(APIUrls.PROJECT(projectId), projectResource).then((res)=>{
              dispatch(projectCreationStepFilter("Source Material Step 1"))   
              dispatch(updateSourceLanguage({})); 
              dispatch(updateTargetLanguage([]));   
              dispatch(departmentSelected(""))
              dispatch(updateInitializedProjectWorkflows([]));
              dispatch(updateProjectInfoValidation({}));
              dispatch(updateProjectInfoConfiguration({}));
              dispatch(updateProjectInfo({}));
              navigate(`/createProject/${projectId}`);
            });
            
        })
        .catch((err) => {
          console.error("Error post request");
        });
      
  }

  const rowClicked = (row, event) => {
    const isStatusClicked = $(document.activeElement).parent().is('[id*="project.status"]');
    if (isStatusClicked) {
      $(document.activeElement).addClass('focusStatus');
    }
    getAxiosResponse(
      APIUrls.PROJECT_LIST_DETAIL(row.id) )
      .then((res) => {
        if (res.data.code === 200) {
          setProjectDetail(res.data.data);
        }
      })
      .catch((err) => {
        console.error(err);
      });
    showRightModel(true);
  };
  const handlingRowClicked = (event, row) => {
    if (event.key===Constants.ENTER) {
      rowClicked(row);
    }
  };

  const fetchProjectData = async (page) => {    
    if(state !== null && state!== undefined){
      showLoader(true);
      showGlobalOverlay(true)
    }
    //toggleLoader(true);
    var url = getFilterUrl();    
    let projectListUrl = APIUrls.PROJECT_LIST +
        `?${url}onlyFollowed=${followed}&page=${page}&pageSize=${perPage}${projectType}${dateRangeIntial}${departmentId}${sort}${searchParameter}`
    if(sort.trim()==""){      
    projectListUrl = APIUrls.PROJECT_LIST +
        `?${url}onlyFollowed=${followed}&page=${page}&pageSize=${perPage}${projectType}${dateRangeIntial}${departmentId}&sortOrder=DESC&sortColumn=project.createdDate${searchParameter}`
    }
    await getAxiosResponse(
      projectListUrl
    )
      .then((res) => {
        if (res.data !== "") {
          updateList(res.data.data.result);
          setTotalRows(res.data.data.resultCount);

          setTimeout(() => {            
            $(".rdt_TableCol_Sortable[data-column-id='project.createdDate']")
      .attr({ 'aria-label': "Created On", 'aria-sort': Constants.DESCENDING});
            if(sortFocus){            
              $(".rdt_TableCol_Sortable[data-column-id='" + sortFocus + "']").trigger('focus');
              setsortFocus('');              
            }
            if (paginationRef.current) {
                  $('#'+ paginationRef.current).trigger('focus');
                  paginationRef.current = '';
              }
            }, 300);

        }
      })
      .catch((err) => {
        console.error(err);
      });
    showLoader(false);
    showGlobalOverlay(false)
  };

  const fetchGlobalSearchData = (page)=>{    
    getAxiosResponse(`${APIUrls.PROJECT_LIST}?&page=${page}&pageSize=${perPage}${searchParameter}&globalSearch=${globalSearch}`)
    .then((res) => {
      if (res.data !== "") {
        updateList(res.data.data.result);
        setTotalRows(res.data.data.resultCount);
      }
    }).catch((err) => {
      console.error(err);
    });
    showLoader(false);
  };

  const handlePerRowsChange = async (newPerPage, page) => {    
    showLoader(true);
    showGlobalOverlay(true)
    await getAxiosResponse(
      APIUrls.PROJECT_LIST +
        `?onlyFollowed=${followed}&page=${page}&pageSize=${newPerPage}${projectType}${dateRangeIntial}${departmentId}${sort}${searchParameter}`
    ).then((res) => {
        if (res.data !== "") {
          updateList(res.data.data.result);
          setPerPage(newPerPage);
          setTimeout(function(){
            $('.datatable-block').find('nav.rdt_Pagination select').trigger('focus');
          }, 100);
        }
      }).catch((err) => {
        console.error(err);
      });
    showLoader(false);
    showGlobalOverlay(false)
  };

  $(".rdt_Table").attr("aria-label","Projects"); 

  const handlePageChange = (paging) => {
    updateCurrentPage(paging);
    if ($('#pagination-last-page').attr('aria-disabled')==="true") {
      paginationRef.current = $('#pagination-previous-page').attr('id');
    } else if ($('#pagination-first-page').attr('aria-disabled')==="true") {
      paginationRef.current = $('#pagination-next-page').attr('id');
    } else {
      paginationRef.current = document.activeElement.id;
    }
  };

  const handleSort = async (column, sortDirection) => {    
    var order = sortDirection.toUpperCase();
    var sortedColumn = column.id;
    var sortedString = `&sortOrder=${order}&sortColumn=${sortedColumn}`;    
    $(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']")
      .attr({ 'aria-label': column.name, 'aria-sort': order === Constants.DESC ? Constants.DESCENDING : Constants.ASCENDING });  
    setSort(sortedString);
  };

 ;
  useEffect(() => {
    $('.lastdisable').trigger('focus')
  }, []);
  useEffect(() => {
    // showLoader(true)
    if(globalSearch === true){
      //fetchGlobalSearchData(currentPage);
    }else{
      fetchProjectSearchCount();
    }
   
  }, [followed, departmentId, dateRangeIntial, projectFilters, searchText]);

  const fetchProjectSearchCount = ()=>{
    var url = getFilterUrl();
    getAxiosResponse(APIUrls.PROJECT_DELIVERY_STATUS_COUNT +`?${url}onlyFollowed=${followed}${departmentId}&page=1${dateRangeIntial}${searchParameter}`)
    .then((res) => {
      if (res.data.code === 200) {
        showLoader(false)
        showGlobalOverlay(false)
        updateCount(res.data.data);
      }
    }).catch((err) => {
        console.error(err);
    });
  };

  const getFilterUrl = () => {
    var url = ``;
    Object.entries(projectFilters).map(([label, value]) => {
      if(value.label?.length !== 0) {
        if(label === Constants.CAMPAIGN) {
          url = url + `workspaceId=${value.value}&`;
        }
        if(label === Constants.DELIVERY_STATUS) {
          url = url + `deliveryStatus=${value.value}&`;
        }
        if(label === Constants.CONTENT_SOURCE) {
          url = url + `projectContentType=${value.value}&`;
        }
        if(label === Constants.INTENDED_USE) {
          url = url + `customerIntendedUseId=${value.value}&`;
        }
        if(label === Constants.PROJECT_ID) {
          url = url + `projectId=${value.label}&`;
        }
        if(label === Constants.TRANSLATIONS_BY) {
          url = url + `vendorId=${value.value}&`;
        }
        if(label === Constants.PROJECT_OWNER) {
          url = url + `ownerId=${value.value}&`;
        }
        if(label === Constants.PURCHASE_ORDER) {
          url = url + `purchaseOrder=${value.value}&`;
        }
        if(label === Constants.SOURCE_LANGUAGE) {
          url = url + `sourceLanguage=${value.value}&`;
        }
        if(label === Constants.TAGS) {
          url = url + `tag=${value.label}&`;
        }
        if(label === Constants.TARGET_LANGUAGE) {
          url = url + `targetLanguage=${value.value}&`;
        }
      }
    })
    return url;
  };

  useEffect(() => {    
    if(globalSearch === false){
      var url = getFilterUrl();    
      getAxiosResponse(APIUrls.PROJECT_LIST +`?${url}page=${currentPage}&pageSize=${perPage}${dateRangeIntial}`).then((res) => {
        if (res.data !== "") {
          updateList(res.data.data.result);
          setTotalRows(res.data.data.resultCount);
          showLoader(false);
        showGlobalOverlay(false)
        }
      }).catch((err) => {
          console.error(err);
      });
    }
  }, [projectFilters]);

  function removeFilter(removableLabel) {
    dispatch(setDefaultValueForFilter({type : removableLabel, payload : {label : '', value : ''}}))

    const selectedElement = $(document.activeElement).closest(".selected-data");
    if($(document.activeElement).parent('li').is(':last-child') &&
      selectedElement.children().length > 1){
        selectedElement.find('li:nth-last-child(2) button').trigger('focus');
    } else if($(document.activeElement).is(':last-child') && selectedElement.children().length === 1){
      $(document.activeElement).closest(".campaign-section").find('.lastdisable').trigger('focus');
    } else {
      $(document.activeElement).parent().next().find('button').trigger('focus');
    }

  };

  useEffect(() => {    
    if(searchText!== '' || selectedDepatmentRedux !== '' || followed === true){
      setTimeout(()=>{
        var element = document.getElementById("filterBtn");
        var element2 = document.getElementById("activeId");
        element?.classList?.add("show-flex");
        element2?.classList?.add("active");
      },1000)
    }
    if(globalSearch === "true"){
      fetchGlobalSearchData(currentPage);
      showLoader(false);
      showGlobalOverlay(false)
    }else{
      if(prevPayload.selectedDateRangeRedux){
        fetchProjectData(currentPage);
      }
    }
    getAllTemplates();
  }, [prevPayload]);

useEffect(()=>{
  var payload = {
    'projectType':projectType,
    'selectedDepatmentRedux':selectedDepatmentRedux,
    'selectedDateRangeRedux':selectedDateRangeRedux,
    'sort':sort,
    'currentPage':currentPage,
    'followed':followed,
    'projectFilters':projectFilters,
    'searchText':searchText
  }
  if( JSON.stringify(payload) !== JSON.stringify(prevPayload) ){
    setPrevPayload(payload)
  }
},[ projectType,
  selectedDateRangeRedux,
  selectedDepatmentRedux,
  sort,
  currentPage,
  followed,
  projectFilters,
  searchText])
  var biddingCount = 0
  //Tutorial Tips start
  function doArrow(position, verticalAlign, horizontalAlign) {
    if (!position) {
      return {};
    }
    const width = 16;
    const height = 12;
    const color = "white";
    const isVertical = position === "top" || position === "bottom";
    const spaceFromSide = 10;
  
    const obj = {
      [`--rtp-arrow-${isVertical ? opositeSide[horizontalAlign] : verticalAlign}`]: height + spaceFromSide + "px",
      [`--rtp-arrow-${opositeSide[position]}`]: -height + 2 + "px",
      [`--rtp-arrow-border-${isVertical ? "left" : "top"}`]: `${width / 2}px solid transparent`,
      [`--rtp-arrow-border-${isVertical ? "right" : "bottom"}`]: `${width / 2}px solid transparent`,
      [`--rtp-arrow-border-${position}`]: `${height}px solid ${color}`
    };
    return obj;
  }

  const styles = {
    popover: (base, state) => {
     return {
        ...base,
       ...doArrow(state.position, state.verticalAlign, state.horizontalAlign),
       '--reactour-accent': '#154da1',
       };
    }
  };

  const opositeSide = {
    top: "bottom",
    bottom: "top",
    right: "left",
    left: "right"
  };
  
  const prevButton= ({ currentStep, setCurrentStep, steps }) => {
    const first = currentStep === 0
    $(`.tutorial-left-arr + div button:nth-child(${currentStep + 1})`).trigger('focus')
    $(`.tutorial-left-arr + div button`).each(
      function(index, item){
        $(item).attr('aria-label','Go to step ' + (index + 1))
      }
    )
    $(`.tutorial-left-arr + div button:nth-child(${currentStep + 1})`).attr('aria-label','current step '+ (parseInt(currentStep,10) + 1))
    return (
      <button aria-label="go to previous" disabled={first ? "disabled" : ""} className={first ? "tutorial-left-arr tutorial-disable" : "tutorial-left-arr"}
        onClick={() => {
          if (first) {
            setCurrentStep((s) => steps.length - 1)
          } else {
            setCurrentStep((s) => s - 1)
          }
        }}
      >
        <svg viewBox="0 0 18.4 14.4"><path d="M1.4 7.2h16M7.6 1L1.4 7.2l6.2 6.2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10"></path></svg>
      </button>
    )
   };
   const nextButton= ({ currentStep, setCurrentStep, steps, stepsLength, setIsOpen }) => {
    const last = currentStep === stepsLength - 1
    $(`.tutorial-left-arr + div button:nth-child(${currentStep + 1})`).trigger('focus')
    $(`.tutorial-left-arr + div button`).each(
      function(index, item){
        $(item).attr('aria-label','Go to step ' + (index + 1))
      }
    )
    $(`.tutorial-left-arr + div button:nth-child(${currentStep + 1})`).attr('aria-label','current step '+ (parseInt(currentStep,10) + 1))
    return (
      <>
      {last ? (
        <button className="finish-btn"
          onClick={() => {
          if (last) {
            setIsOpen(false)
          } else {
            setCurrentStep((s) => (s === steps?.length - 1 ? 0 : s + 1))
          }
         }}
        >Finish</button>
      ) : (
        <button aria-label="go to next" disabled={last ? "disabled" : ""} className={last ? "tutorial-right-arr tutorial-disable" : "tutorial-right-arr"}
        onClick={() => {
          if (last) {
            setIsOpen(false)
          } else {
            setCurrentStep((s) => (s === steps?.length - 1 ? 0 : s + 1))
          }
         }}
        >
        <svg viewBox="0 0 18.4 14.4"><path d="M17 7.2H1M10.8 1L17 7.2l-6.2 6.2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10"></path></svg>
        </button>
      )}
      </>
    )
  
   }
  const closeRightModal = () =>{
    showRightModel(false)
    setOpenfilter(false)
    document.body.classList.remove("modal-open");
  }
  const disableBody = (target) => disableBodyScroll(target)
  const enableBody = (target) => enableBodyScroll(target)
  const projectlistingTutorial = () =>{
    document.body.classList.add("modal-open-2");
    $('#filterBtn').addClass('show-flex');
    $('#activeId').addClass('filter-tour')
    $(".nextFocus2").on("keydown", function (e) {
      if (e.key === Constants.TAB) {
        if (e.shiftKey === false) {
          e.preventDefault();
          $(".cancelFocus2").trigger("focus");
        }
      }
    });
    setTimeout(() => {
      $(".cancelFocus2").trigger("focus");
      $(".cancelFocus2").on("keydown", function (e) {
        if (e.key === Constants.TAB) {
          if (e.shiftKey === true) {
            e.preventDefault();
            $(".nextFocus2").trigger("focus");
          }
        }
      });
      $(".inner-lightbox-panel").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
          document.body.classList.remove("modal-open-2");
          $('.focusAdd').trigger('focus');
          $('.tutorial-tips').removeClass('focusAdd');
        }
      });
    }, 500);
  };
 //Tutorial Tips end

  const crumbs = [{label:'Projects', url:`projects`}];
  function showHide() {
    var element = document.getElementById("progress-btn");
    if(element !==undefined && element !==null){
      element.classList.toggle("show");
      $('.circle').attr('aria-expanded', function(index, attr){
        return attr === 'true' ? 'false': 'true';
      });
      $(document).mouseup(function(e) {
        var bannerCont = $('.name-card-section-right');
        if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
          showHide()
        }
      });
    }
  };

  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
      <TourProvider
          steps={steps}
          styles={styles}
          prevButton={prevButton}
          nextButton={nextButton}
          afterOpen={disableBody}
          beforeClose={enableBody}
          onClickMask={({ currentStep, steps, setIsOpen }) => {
            if (steps) {
              if (currentStep === steps.length - 1) {
                setIsOpen(true)
               }
              }
          }}
          badgeContent={({ totalSteps, currentStep }) => currentStep + 1 + "/" + totalSteps}
          >
          <Header ref={scrollRef} func={projectlistingTutorial}/>
          <LeftNavbar />
        </TourProvider>
        <section className="dashboard-content" ref={scrollRef}>
          <div id="content" className="dashboard-wrap campaign-section">
            <Breadcrumb crumbs={ crumbs } />
            <div className="dashboard-top flex-center">
              <div className="flex-left flex-center">
                <div className="fliter">
                  <button id="activeId" className="dashboard-btn" onClick={filterFunction} projectlisting-tour="filter" aria-expanded="true" >
                    <span className="filter-icon">
                      {FilterIcon}
                    </span>{" "}
                    Filters
                  </button>
                </div>
              </div>
              <div className="flex-right flex-center btn-gap10">
              {getPermissionsRedux.includes('CREATE_PROJECT')? (
                <>
                <ConditionalBlock condition={templates.length === 0}>
                  <button className="dashboard-btn" onClick={createProject}>
                  {PlusIcon} New {translate('new_project')}
                  </button>
                </ConditionalBlock>
                <ConditionalBlock condition={templates.length>0}>
                  <div className="name-card-section-right ">
                    <div className="projectDeatilsDot" onClick={showHide}
                        role="button" aria-label="Task Type" aria-expanded="false" tabIndex="0" projectdetail-tour="clone-project" >
                      <button className="dashboard-btn" >
                        {PlusIcon} Start New
                      </button>
                    </div>
                    <div className="progress-btn min-width-190" id="progress-btn" >
                        <div className="inner-popover project-btn">
                          <button className="dashboard-btn" onClick={createProject}>
                            {translate('new_project')}
                          </button>
                          <button className="dashboard-btn" onClick={openTemplateModal}>
                            {translate('new_project_with_template')}
                          </button>
                        </div>
                    </div>
                  </div>
                </ConditionalBlock>
                </>
              ) : null }
              </div>
            </div>
            <div>&nbsp;</div>
            <FilterProject filter={prop.filterType} funct={showRightModel} setSearchText={setSearchText} searchText={searchText}/>
            <div className="wrap-data listing-wrap-data">
              <div className="listing-tab-block flex">
                {/* <div className="additional-filter">
                <Link to="#" onClick={()=>
                    showRightModel(false)} aria-expanded="false" id="project-filters">
                    Additional Filters
                  </Link>
                 </div> */}
                <ul className="listing-tab-link flex" projectlisting-tour="tabs" role="tablist">
                    <li role="none">
                      <button
                        role="tab"
                        aria-label={projectType === "" || projectType === "&projectStatusAllTranslationApproved=true" || projectType ==="&projectStatusChangeOrderRequested=true&projectStatusInTranslation=true&projectStatusInCancellation=true&" || projectType === "&projectStatusSubmittedForBids=true&projectStatusWaitingForBidSelection=true&projectStatusWaitingForInternalTranslator=true&projectStatusRejectedByInternalTranslator=true&projectStatusWaitingForVendorAcceptance=true&projectStatusRejectedByVendor=true"  ?
                         "Current tab " + translate("project_listing.all") : translate("project_listing.all")}
                         aria-selected={projectType === "" || projectType === "&projectStatusAllTranslationApproved=true" || projectType ==="&projectStatusChangeOrderRequested=true&projectStatusInTranslation=true&projectStatusInCancellation=true&" || projectType === "&projectStatusSubmittedForBids=true&projectStatusWaitingForBidSelection=true&projectStatusWaitingForInternalTranslator=true&projectStatusRejectedByInternalTranslator=true&projectStatusWaitingForVendorAcceptance=true&projectStatusRejectedByVendor=true" ? "true" : "false"}
                        className={(projectType === "" || projectType === "&projectStatusAllTranslationApproved=true" || projectType ==="&projectStatusChangeOrderRequested=true&projectStatusInTranslation=true&projectStatusInCancellation=true&" || projectType === "&projectStatusSubmittedForBids=true&projectStatusWaitingForBidSelection=true&projectStatusWaitingForInternalTranslator=true&projectStatusRejectedByInternalTranslator=true&projectStatusWaitingForVendorAcceptance=true&projectStatusRejectedByVendor=true" )
                        ? "active" : ""}
                        ref={(projectType === "" || projectType === "&projectStatusAllTranslationApproved=true" || projectType ==="&projectStatusChangeOrderRequested=true&projectStatusInTranslation=true&projectStatusInCancellation=true&" || projectType === "&projectStatusSubmittedForBids=true&projectStatusWaitingForBidSelection=true&projectStatusWaitingForInternalTranslator=true&projectStatusRejectedByInternalTranslator=true&projectStatusWaitingForVendorAcceptance=true&projectStatusRejectedByVendor=true" ) 
                        ? tabRef : null}
                        onClick={() => {
                          updateCurrentPage(1);
                          setType("");
                        }}
                      >
                      {translate("project_listing.all")}{" "}

                      </button>
                    </li>
                    {data?.length > 0 && 
                    projectDeliveryStatusCount.map((deliveryStatusCount) => {
                      if( (deliveryStatusCount.status === "projectStatusSubmittedForBids") 
                      || (deliveryStatusCount.status === "projectStatusWaitingForBidSelection") 
                      || (deliveryStatusCount.status === "projectStatusWaitingForInternalTranslator") 
                      || (deliveryStatusCount.status === "projectStatusRejectedByInternalTranslator") 
                      || (deliveryStatusCount.status === "projectStatusWaitingForVendorAcceptance") 
                      || (deliveryStatusCount.status === "projectStatusRejectedByVendor") 
                      ){
                        biddingCount += deliveryStatusCount.count
                      }
                      })}
                       {biddingCount > 0 ? <li key="projectStatusInTranslation" role="none">
                          <button
                          className={projectType === '&projectStatusSubmittedForBids=true&projectStatusWaitingForBidSelection=true&projectStatusWaitingForInternalTranslator=true&projectStatusRejectedByInternalTranslator=true&projectStatusWaitingForVendorAcceptance=true&projectStatusRejectedByVendor=true&bidding=true' ? "active" : ""}
                          ref={projectType === "inBidding" ? tabRef : null}
                            onClick={() => {
                              updateCurrentPage(1);
                              setType("&projectStatusSubmittedForBids=true&projectStatusWaitingForBidSelection=true&projectStatusWaitingForInternalTranslator=true&projectStatusRejectedByInternalTranslator=true&projectStatusWaitingForVendorAcceptance=true&projectStatusRejectedByVendor=true&bidding=true");
                            }}
                            role="tab"
                            aria-label={projectType === '&projectStatusSubmittedForBids=true&projectStatusWaitingForBidSelection=true&projectStatusWaitingForInternalTranslator=true&projectStatusRejectedByInternalTranslator=true&projectStatusWaitingForVendorAcceptance=true&projectStatusRejectedByVendor=true&bidding=true' ? "Current tab " + `In Bidding ${biddingCount}` : `In Bidding ${biddingCount}`}
                            aria-selected={projectType === "&projectStatusSubmittedForBids=true&projectStatusWaitingForBidSelection=true&projectStatusWaitingForInternalTranslator=true&projectStatusRejectedByInternalTranslator=true&projectStatusWaitingForVendorAcceptance=true&projectStatusRejectedByVendor=true&bidding=true" ? "true" : "false"}
                          >
                        {translate("project_listing.in_bidding")}

                            <span>{biddingCount}</span>
                          </button>
                        </li> : '' }
                    {data?.length > 0 && projectDeliveryStatusCount.map((deliveryStatusCount) => {
                      
                      switch (deliveryStatusCount.status) {
                        case "projectStatusInReview":
                          return (
                            <li key="projectStatusInReview" role="none">
                              <button
                                role="tab"
                                aria-label={projectType === "&projectStatusInReview=true" ? "Current tab " + `${translate("project_listing.in_review")} ${deliveryStatusCount.count}` : `${translate("project_listing.in_review")} ${deliveryStatusCount.count}`}
                                aria-selected={projectType === "&projectStatusInReview=true" ? "true" : "false"}
                                className={projectType === "&projectStatusInReview=true" ? "active" : ""}
                                ref={projectType === "&projectStatusInReview=true" ? tabRef : null}
                                onClick={() => {
                                  updateCurrentPage(1);
                                  setType("&projectStatusInReview=true");
                                }}
                              >
                                {translate("project_listing.in_review")}{" "}

                                <span>{deliveryStatusCount.count}</span>
                              </button>
                            </li>
                          );
                        case "projectStatusInTranslation":
                          return (
                            <li key="projectStatusInTranslation" role="none">
                              <button
                                role="tab"
                                aria-label={projectType === "&projectStatusInTranslation=true" ? "Current tab " + `${translate("project_listing.in_translation")} ${deliveryStatusCount.count}` : `${translate("project_listing.in_translation")} ${deliveryStatusCount.count}`}
                               aria-selected={projectType === "&projectStatusInTranslation=true" ? "true" : "false"}
                              className={projectType === "&projectStatusInTranslation=true" ? "active" : ""}

                              ref={projectType === "&projectStatusInTranslation=true" ? tabRef : null}
                                onClick={() => {
                                  updateCurrentPage(1);
                                  setType("&projectStatusInTranslation=true");
                                }}
                              >
                                {translate("project_listing.in_translation")}{" "}
                                <span>{deliveryStatusCount.count}</span>
                              </button>
                            </li>
                          );
                          
                          
                          case "projectStatusAllTranslationApproved":
                          return (
                            <li key="projectStatusAllTranslationApproved" role="none">
                              <button
                              role="tab"
                              className={projectType === "&projectStatusAllTranslationApproved=true&allLanguageApproved=true"  ? "active" : ""}
                              ref={projectType === "&projectStatusAllTranslationApproved=true&allLanguageApproved=true" ? tabRef : null}
                                onClick={() => {
                                  updateCurrentPage(1);
                                  setType("&projectStatusAllTranslationApproved=true&allLanguageApproved=true");
                                }}
                                aria-label={projectType === "&projectStatusAllTranslationApproved=true&allLanguageApproved=true" ? "Current tab " + `All language approved ${deliveryStatusCount.count}` : `All language approved ${deliveryStatusCount.count}`}
                                aria-selected={projectType === "&projectStatusAllTranslationApproved=true&allLanguageApproved=true" ? "true" : "false"}
                              >
                                All language approved
                                <span>{deliveryStatusCount.count}</span>
                              </button>
                            </li>
                          );
                        case "projectStatusClosed":
                          return (
                            <li key="projectStatusClosed" role="none">
                              <button
                                role="tab"
                                aria-label={projectType === "&projectStatusClosed=true" ? "Current tab " + `Closed ${deliveryStatusCount.count}` : `Closed ${deliveryStatusCount.count}`}
                                aria-selected={projectType === "&projectStatusClosed=true" ? "true" : "false"}
                                className={projectType === "&projectStatusClosed=true" ? "active" : ""}
                                ref={projectType === "&projectStatusClosed=true" ? tabRef : null}
                                onClick={() => {
                                  updateCurrentPage(1);
                                  setType("&projectStatusClosed=true");
                                }}
                              >
                                Closed <span>{deliveryStatusCount.count}</span>
                              </button>
                            </li>
                          );
                        case "projectStatusCanceled":
                          return (
                            <li key="projectStatusCanceled" role="none">
                              <button
                                role="tab"
                                aria-label={projectType === "&projectStatusCanceled=true" ? "Current tab " + `Canceled ${deliveryStatusCount.count}` : `Canceled ${deliveryStatusCount.count}`}
                                aria-selected={projectType === "&projectStatusCanceled=true" ? "true" : "false"}
                                className={projectType === "&projectStatusCanceled=true" ? "active" : ""}
                                ref={projectType === "&projectStatusCanceled=true" ? tabRef : null}
                                onClick={() => {
                                  updateCurrentPage(1);
                                  setType("&projectStatusCanceled=true");
                                }}
                              >
                                Canceled<span>{deliveryStatusCount.count}</span>
                              </button>
                            </li>
                          );
                        case "projectStatusBidSelectionExpired":
                          return (
                            <li key="projectStatusBidSelectionExpired" role="none">
                              <button
                               role="tab"
                               aria-label={projectType === "&projectStatusInBidding=true&projectStatusBidSelectionExpired=true" ? "Current tab " + `Bid Selection Expired ${deliveryStatusCount.count}` : `Bid Selection Expired ${deliveryStatusCount.count}`}
                               aria-selected={projectType === "&projectStatusInBidding=true&projectStatusBidSelectionExpired=true" ? "true" : "false"}
                              className={projectType === "&projectStatusInBidding=true&projectStatusBidSelectionExpired=true" ? "active" : ""}
                              ref={projectType === "&projectStatusInBidding=true&projectStatusBidSelectionExpired=true" ? tabRef : null}
                                onClick={() => {
                                  updateCurrentPage(1);
                                  setType(
                                    "&projectStatusInBidding=true&projectStatusBidSelectionExpired=true"
                                  );
                                }}
                              >
                              Quote Selection Expired
                                <span>{deliveryStatusCount.count}</span>
                              </button>
                            </li>
                          );
                        case "projectStatusWaitingForBidSelection":
                          return (
                            <li key="projectStatusWaitingForBidSelection" role="none">
                              <button
                               role="tab"
                               aria-label={projectType === "&projectStatusInBidding=true&projectStatusWaitingForBidSelection=true" ? "Current tab " + `Waiting For Bid Selection ${deliveryStatusCount.count}` : `Waiting For Bid Selection ${deliveryStatusCount.count}`}
                                aria-selected={projectType === "&projectStatusInBidding=true&projectStatusWaitingForBidSelection=true" ? "true" : "false"}
                                className={projectType === "&projectStatusInBidding=true&projectStatusWaitingForBidSelection=true" ? "active" : ""}
                                ref={projectType === "&projectStatusInBidding=true&projectStatusWaitingForBidSelection=true" ? tabRef : null}
                                onClick={() => {
                                  updateCurrentPage(1);
                                  setType(
                                    "&projectStatusInBidding=true&projectStatusWaitingForBidSelection=true"
                                  );
                                }}
                              >
                               {translate("project_listing.waiting_for_bid_selection")}
                                <span>{deliveryStatusCount.count}</span>
                              </button>
                            </li>
                          );
                        case "projectStatusAllBidsRejected":
                          return (
                            <li key="projectStatusAllBidsRejected" role="none">
                              <button
                               role="tab"

                               aria-label={projectType === "&projectStatusInBidding=true&projectStatusAllBidsRejected=true" ? "Current tab " + ` Bid rejected ${deliveryStatusCount.count}` : ` Bid rejected ${deliveryStatusCount.count}`}

                               aria-selected={projectType === "&projectStatusInBidding=true&projectStatusAllBidsRejected=true" ? "true" : "false"}
                              className={projectType === "&projectStatusInBidding=true&projectStatusAllBidsRejected=true" ? "active" : ""}
                              ref={projectType === "&projectStatusInBidding=true&projectStatusAllBidsRejected=true" ? tabRef : null}
                                onClick={() => {
                                  updateCurrentPage(1);
                                  setType(
                                    "&projectStatusInBidding=true&projectStatusAllBidsRejected=true"
                                  );
                                }}
                              >
                                Quote rejected{" "}
                                <span>{deliveryStatusCount.count}</span>
                              </button>
                            </li>
                          );
                          
                        case "projectStatusInCreation":
                          return (
                            <li key="projectStatusInCreation" role="none">
                              <button className={(projectType === "&projectStatusInCreation=true" || projectType === "&projectStatusInCreation=true&projectStatusBidSelectionExpired=true&projectStatusAllBidsRejected=true" )
                              ? "active" : ""}
                              role="tab"

                              aria-label={projectType === "&projectStatusInCreation=true" || projectType === "&projectStatusInCreation=true&projectStatusBidSelectionExpired=true&projectStatusAllBidsRejected=true"? "Current tab " + `${translate("project_listing.in_creation")} ${deliveryStatusCount.count}` : `${translate("project_listing.in_creation")} ${deliveryStatusCount.count}`}

                              aria-selected={projectType === "&projectStatusInCreation=true" || projectType === "&projectStatusInCreation=true&projectStatusBidSelectionExpired=true&projectStatusAllBidsRejected=true" ? "true" : "false"}
                              ref={(projectType === "&projectStatusInCreation=true" || projectType === "&projectStatusInCreation=true&projectStatusBidSelectionExpired=true&projectStatusAllBidsRejected=true")
                               ? tabRef : null}
                                onClick={() => {
                                  updateCurrentPage(1);
                                  setType("&projectStatusInCreation=true");
                                }}
                              >
                               {translate("project_listing.in_creation")} {" "}
                                <span>{deliveryStatusCount.count}</span>
                              </button>
                            </li>
                          );
                        case "projectStatusChangeOrderRequested":
                          return (
                            <li key="projectStatusChangeOrderRequested" role="none">
                              <button
                                className={
                                  projectType ===
                                  "&projectStatusChangeOrderRequested=true"
                                    ? "active"
                                    : ""
                                }
                                role="tab"

                               aria-label={projectType ===
                                "&projectStatusChangeOrderRequested=true" ? "Current tab " + `${translate("project_listing.change_order_requested")} ${deliveryStatusCount.count}` : `${translate("project_listing.change_order_requested")} ${deliveryStatusCount.count}`}

                                aria-selected={projectType === "&projectStatusChangeOrderRequested=true" ? "true" : "false"}
                                ref={
                                  projectType ===
                                  "&projectStatusChangeOrderRequested=true"
                                    ? tabRef
                                    : null
                                }
                                onClick={() => {
                                  updateCurrentPage(1);
                                  setType(
                                    "&projectStatusChangeOrderRequested=true"
                                  );
                                }}
                              >
                                {translate("project_listing.change_order_requested")} {" "}
                                <span>{deliveryStatusCount.count}</span>
                              </button>
                            </li>
                          );
                        case "projectStatusWaitingForVendorAcceptance":
                          return (
                            <li key="projectStatusWaitingForVendorAcceptance" role="none">
                              <button
                                className={
                                  projectType ===
                                  "&projectStatusWaitingForVendorAcceptance=true"
                                    ? "active"
                                    : ""
                                }
                                role="tab"

                                aria-label=  {projectType ===
                                "&projectStatusWaitingForVendorAcceptance=true" ? "Current tab " + `${translate("project_listing.waiting_for_vendor")} ${deliveryStatusCount.count}` : `${translate("project_listing.waiting_for_vendor")} ${deliveryStatusCount.count}`}

                                aria-selected={projectType === "&projectStatusWaitingForVendorAcceptance=true" ? "true" : "false"}
                                ref={
                                  projectType ===
                                  "&projectStatusWaitingForVendorAcceptance=true"
                                    ? tabRef
                                    : null
                                }
                                onClick={() => {
                                  updateCurrentPage(1);
                                  setType(
                                    "&projectStatusWaitingForVendorAcceptance=true"
                                  );
                                }}
                              >
                               { translate("project_listing.waiting_for_vendor")}{" "}

                                <span>{deliveryStatusCount.count}</span>
                              </button>
                            </li>
                          );
                        case "projectStatusInError":
                          return (
                            deliveryStatusCount.count > 0 ?
                            <li key="projectStatusInError" role="none">
                              <button className={projectType ==="&projectStatusInError=true"? "active": ""}
                               role="tab"
                               aria-label={projectType ==="&projectStatusInError=true" ? "Current tab " + `Error${deliveryStatusCount.count}` : `Error ${deliveryStatusCount.count}`}
                               aria-selected={projectType ==="&projectStatusInError=true" ? "true" : "false"}
                                ref={projectType ==="&projectStatusInError=true"? tabRef: null}
                                onClick={() => {
                                  updateCurrentPage(1);
                                  setType("&projectStatusInError=true");
                                }}>
                                 {translate("project_page.error")}
                                <span>{deliveryStatusCount.count}</span>
                              </button>
                            </li>:''
                          );
                        default:
                          return "";
                      }
                    
                    })}
                    
                  </ul>
              </div>
              <div className="white-bg">
                <div className="campaign-hedaing flex justify-center">
                  <ul className="selected-data flex">
                    {Object.entries(projectFilters).map(([label, value]) => {
                      if (value.label?.length !== 0 && value.label !== Constants.SELECT) {
                        return (
                          <li key={label}>
                            <button onClick={(e) => {removeFilter(label)}}>
                              <p aria-label={`Remove ${label.replace("_", " ")} : ${value.label}`} >
                                <small>{label.replace("_", " ")} : </small> {value.label}
                              </p>
                              <span>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="10"
                                  height="10"
                                  viewBox="0 0 10 10"
                                  fill="none"
                                >
                                  <path
                                    d="M1.50533 8.49531L5.00067 4.99997M8.496 1.50464L5 4.99997M5 4.99997L1.50533 1.50464M5.00067 4.99997L8.496 8.49531"
                                    stroke="#213248"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </span>
                            </button>
                          </li>
                        );
                      }
                    })}

                  </ul>
                </div>
               
                <div className="datatable-block">
                  <DataTable
                    keyField="id"
                    columns={columns}
                    data={data}
                    theme={theme}
                    sortServer
                    selectableRowsVisibleOnly={true}
                    defaultSortFieldId="project.createdDate"
                    defaultSortAsc={false} 
                    responsive
                    striped
                    selectableRowsHighlight={true}
                    onSelectedRowsChange={handleChange}
                    pagination
                    onSort={handleSort}
                    pointerOnHover={true}
                    onRowClicked={(row, event) => {
                      rowClicked(row, event);
                    }}
                    selectableRowsNoSelectAll={true}
                    selectableRowsSingle={true}
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangeRowsPerPage={handlePerRowsChange}
                    paginationRowsPerPageOptions={[10, 20, 40, 50, 100, 200]}
                    onChangePage={handlePageChange}
                    // progressPending={loader}
                    noDataComponent={noDataFoundComponent()}
                  />
                </div>
                  
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className={globalOverlay ? "gb-overlay show" : "gb-overlay hide"}>
      <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={true}
          />
        </div>
      </div>
      <div className="overlay" onClick={closeRightModal}></div>
      {selectRighModal ? <ProjectDetailModal row_detail={projectDetail}/> : openFilter ? <RightModal funct={showRightModel} /> : null}
      
      <ProjectCreationWithTemplate templates={templates}/>
    </div>
  );
}
